import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export interface SiteFeatureItem {
  bold: string;
  text: string;
}

export interface SiteStatItem {
  icon: string;
  value: string;
  label: string;
}

export interface SiteSettings {
  site_name?: string;
  site_description?: string;
  logo_url?: string;
  favicon_url?: string;
  email?: string;
  whatsapp?: string;
  facebook?: string;
  instagram?: string;
  tiktok?: string;
  google_site_verification?: string;
  hero_image?: string;
  about_image?: string;
  features_image?: string;
  footer_image?: string;
  header_scripts?: string;
  footer_scripts?: string;
  features_title?: string;
  features_bottom_text?: string;
  features_list?: SiteFeatureItem[];
  home_stats?: SiteStatItem[];
}

export const useSiteSettings = () => {
  return useQuery<SiteSettings | null, Error>({
    queryKey: ["site-settings-public"],
    queryFn: async () => {
      const { data, error } = await supabase.from("site_settings").select("*").single();
      if (error) {
        if (error.code === 'PGRST116') return null;
        console.warn("useSiteSettings fetch failed", error);
        return null;
      }
      
      const settings = data as unknown as SiteSettings;
      return settings;
    },
    staleTime: 1000 * 30, // 30 seconds
  });
};
